import React from "react";

class TenantIcon extends React.Component {
  render() {
    let { name, ...props } = this.props;
    return (
      <span {...props} className={`icon-${this.props.name}`}>
        <span className="path1"></span>
        <span className="path2"></span>
        <span className="path3"></span>
        <span className="path4"></span>
        <span className="path5"></span>
        <span className="path6"></span>
      </span>
    );
  }
}

export default TenantIcon;



// WEBPACK FOOTER //
// ./src/app/components/partials/icons/tenant-icon.jsx